window.addEventListener("noibuSDKReady", async () => {
    const helpCode = await window.NOIBUJS.requestHelpCode(false);
   
    const helpCodeField = document.querySelector("[data-noibu-helpcode]");
    const helpCodeTooltip = document.querySelector("[data-noibu-helpcode-tooltip]");

    helpCodeField.innerHTML = helpCode;
    helpCodeField.setAttribute("aria-label", `Copy help code ${helpCode} to clipboard`);

    helpCodeField.addEventListener("click", () => {
        navigator.clipboard.writeText(helpCode);
        helpCodeTooltip.innerHTML = "Copied to clipboard";

        setTimeout(() => {
            helpCodeTooltip.innerHTML = "Click to copy";
        }, 2000);
    });
   
});